import React from "react";
import styled from "styled-components";
import { rem } from "polished";
import colors from "../../../../../utils/colors";
import { mediaMax } from "../../../../../utils/uiSizes";

const Wrapper = styled.label`
  font-family: FyranSans-Book, sans-serif;
  font-size: 1rem;
  letter-spacing: 0.014em;
  display: block;
  position: relative;
  cursor: pointer;

  padding: 0.25rem 1.75rem 0.5rem 1.75rem;
  color: ${colors.GRAY};
  box-sizing: border-box;

  ${props =>
    props.inline &&
    `
    display: inline-block;
  `} &:focus {
    border-color: ${colors.GRAY};
  }

  &:-webkit-autofill {
    box-shadow: 0 0 0 5em white inset;
  }

  input + span {
    background: white;
    content: "";
    display: inline-block;
    margin: 0 2.5em 0 ${rem("4px")};
    ${mediaMax.phone`
      margin-right: 2rem;
  `};
    padding: ${rem("2px")} 0 0 0;
    vertical-align: top;
    transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;

    &::after {
      content: "";
      display: block;
      transform: scale(0);
      transition: transform 0.2s;
    }

    &::selection {
      background: transparent;
    }
  }

  input:active + span {
    box-shadow: 0 4px 8px rgba(#000, 0.15);
  }

  input:checked + span::after {
    transform: scale(1);
  }

  input {
    position: absolute;
    cursor: pointer;
    opacity: 0;
  }

  input + span {
    border-radius: 4px;

    &::after {
      background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmlld0JveD0iMCAwIDEwIDgiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiNGQjY2NkE7fTwvc3R5bGU+PHBhdGggY2xhc3M9InN0MCIgZD0iTTguNSwwLjNMMy4xLDUuN0wxLjYsNEMxLjMsMy42LDAuNywzLjYsMC4zLDMuOWMtMC40LDAuMy0wLjQsMC45LTAuMSwxLjNsMi4xLDIuNUMyLjUsNy45LDIuNyw4LDMsOGMwLDAsMCwwLDAsMGMwLjIsMCwwLjUtMC4xLDAuNi0wLjNsNi4xLTYuMmMwLjQtMC40LDAuNC0wLjksMC0xLjNDOS40LTAuMSw4LjgtMC4xLDguNSwwLjMiLz48L3N2Zz4=);
      background-size: contain;
      background-repeat: no-repeat;
      width: ${rem("10px")};
      height: ${rem("8px")};
      position: absolute;
      left: ${rem("-27px")};
      top: ${rem("6px")};
    }
  }

  .border {
    border: 1px solid ${colors.WHITE};
    border-radius: ${rem("3px")};
    position: absolute;
    width: ${rem("18px")};
    height: ${rem("18px")};
    left: 0;
    top: 0.25rem;

    &.gray {
      border: 1px solid ${colors.GRAY};
    }
  }

  label {
    min-width: 10rem;
  }
`;

const StyledCheckbox = props => {
  return (
    <Wrapper>
      <input
        type="checkbox"
        value={props.value}
        checked={props.value === true}
        name={props.name}
        onChange={props.onChange}
      />
      <span>{props.label}</span>
      <div className={props.gray ? "border gray" : "border"} />
    </Wrapper>
  );
};

export default StyledCheckbox;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledCheckBox.js